import React from 'react';

/** The gate's verdict is the one thing an operator needs when a provision refuses to run. */
const GateNote = ({ step }) => {
  const detail = step && step.detail;
  if (!detail) return null;
  const blockers = detail.blockers || [];
  const warnings = detail.warnings || [];
  if (blockers.length === 0 && warnings.length === 0) return null;
  return (
    <div className='tdm-gate' data-testid='tdm-gate-note'>
      {blockers.length > 0 && (
        <div className='tdm-gate__blockers'>
          <strong>Blocked:</strong> {blockers.join(' · ')}
        </div>
      )}
      {warnings.length > 0 && (
        <div className='tdm-gate__warnings'>
          <strong>Warnings:</strong> {warnings.join(' · ')}
        </div>
      )}
    </div>
  );
};

export default GateNote;
